module.exports = __webpack_public_path__ + "media/categories/63-0503080c.png";